import { NativeEventBus } from '../native/NativeEventBus';

export const passiveOption = { passive: true };
export const optInString = 'optin';
export const PROFILE_TILE_NAME = 'My Profile';
export const xTenantId = 'betzone_uk';
export const MAX_DEPOSIT_ALLOWED = 50000;
export const countryCode = 'GB';
export const currencyCode = 'GBP';
export const language = 'en';
export const locale = 'en_GB';
export const localeCurrencyCode = 'en-GB';
export const UK__LIMITS_COOLOFF_PERIOD__HOURS = 24;
export const realityCheckMediatorType = 'casino';
export const btag = 'btag';
export const ERROR_STR = 'Error';
export const LIMIT_REASON = 'Requested by user';
export const MESSAGE_SNACKBAR_ID = 1000;
export const INFO_PAGE_SLIDES_NUMBER = 20;

export enum OVERLAYS_ARIA_LABELS {
  SPIN_ZONE = 'spin-zone',
  PERFORMANCE_PROMPT = 'performance-prompt',
}

export enum GAME_CATEGORIES {
  RECOMMENDED = 'Recommended',
}

export const GAME_COOL_OFF_DURATION = 60000; // 300000ms = 5min
export const GAME_INFO_PRE_BREAK_COUNTDOWN = 60000; // 60000ms = 1min

export const INITIAL_INBOX_TIMEOUT = 1000;
export const NATIVE_INBOX_TIMEOUT = 400;

export const SLIDE_MARGIN = 10;
export const SLIDE_HERO_MARGIN = 16;

export const ITV_PRIZES_URL = import.meta.env.VITE_ITV_PRIZES_URL || 'https://www.itv.com/win/';
export const ITV_PRIZES_NATIVE_QUERY = '?mobile=1&app=igaming';

export const MOBILE_SUB_NAV_ITEMS_NUMBER = 5;

export const ZOOMED_GAME_CARD_Z_INDEX = 10000001;

export const getPrizesUrl = (): string => {
  return NativeEventBus.isNativeBridgeAvailable() ? `${ITV_PRIZES_URL}${ITV_PRIZES_NATIVE_QUERY}` : ITV_PRIZES_URL;
};
